// import Layout from '@/components/layout/no-sider-menu-layout/index.vue';
import Layout from '@/components/layout/sider-menu-layout/index.vue';
import type { SiteRouteItem } from '@/router/types';
import { PermissionPageKey } from '@/types/permission';

const route: SiteRouteItem = {
  path: '/my-dashboard',
  component: Layout,
  name: PermissionPageKey.MyDashboard,
  meta: {
    title: 'workplace.my_dashboard.title',
    icon: 'mdi:chart-line',
    iconCls: 'bg-green-500',
    collapseMenuSiderOnMounted: true,
    // ctc-ai 停库期间：我的看板仅管理员可见（恢复后移除本行）
    roles: ['admin'],
  },
  redirect: '/my-dashboard/customer-dashboard', // 默认首页子路由
  children: [
    {
      path: 'customer-dashboard',
      name: PermissionPageKey.CustomerDashboard,
      component: () => import('../pages/customer-dashboard/index.vue'),
      meta: {
        title: 'workplace.my_dashboard.customer_dashboard.title',
        icon: 'material-symbols:add-chart-outline-rounded',
      },
    },
    {
      path: 'dashboard-manage',
      name: PermissionPageKey.DashboardManage,
      component: () => import('../pages/dashboard-manage/index.vue'),
      meta: {
        title: 'workplace.my_dashboard.dashboard_manage.title',
        icon: 'mdi:view-dashboard-edit-outline',
      },
    },
  ],
};

export default route;
